export const hourFormat = (hour) => {
    const regex = /(\d?\d_)?\d*\w?[a-zA-Z]*$/;
    let [hora] = hour.match(regex);
    if (/_/.test(hora)) {
        hora = hora.replace('_', ':');
    } else {
        hora = hora.replace(/[a-zA-Z]?/g, '').concat(':00')
    }
    return hora;
}

export const getFullDate = () => {
    const date = new Date();
    const options = {
        timeZone: "America/Caracas",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    };
    const fecha = date
        .toLocaleString("es-VE", options)
        .split("/")
        .reverse()
        .join("");
    return fecha;
}

export const formatterText = (text) => {
    const splited = text.split('+')
    const sp1 = splited[0]
    const sp2 = splited[1]
    return [sp1, sp2]
}

export const orderInPairs = (objToOrder) => {
    const entries = Object.entries(objToOrder)
    const newArr = []
    let aux = 0
    entries.forEach((element, index) => {
        if (!newArr[aux]) newArr[aux] = []
        newArr[aux].push(element)
        if (index % 2 != 0) aux++
    })
    return newArr
}